import { Link } from "react-router";
import { ExternalLink, Lightbulb } from "lucide-react";
import { formatCount } from "@shared-core/domain/formatters";
import { Card } from "../../primitives/card";
import { paths } from "@shared-core/routing/routes";

interface RecommendationsMetricCardProps {
  urgentCount: number;
  recommendedCount: number;
}

export function RecommendationsMetricCard({
  urgentCount,
  recommendedCount,
}: RecommendationsMetricCardProps) {
  const total = urgentCount + recommendedCount;
  const hasUrgent = urgentCount > 0;

  return (
    <Link to={paths.recommendations()}>
      <Card className="p-4 hover:bg-muted/50 transition-colors cursor-pointer">
        <div className="flex items-start justify-between mb-2">
          <div className="flex-1">
            <div className="text-sm text-muted-foreground mb-1 flex items-center gap-2">
              <Lightbulb className="size-4" />
              Opportunities
            </div>
            <div className="text-3xl font-bold text-foreground">
              {formatCount(total)}
            </div>
            <div className="text-sm text-muted-foreground mt-1">
              {total === 0
                ? "No pending opportunities"
                : `${formatCount(urgentCount)} urgent • ${formatCount(recommendedCount)} recommended`}
            </div>
          </div>
          <div
            className={`
            p-2 rounded-full
            ${hasUrgent ? "bg-primary/20" : "bg-primary/10"}
          `}
          >
            <Lightbulb
              className={`
              size-5
              ${hasUrgent ? "text-primary" : "text-primary/60"}
            `}
            />
          </div>
        </div>

        <div className="text-xs text-primary inline-flex items-center gap-1">
          View all my opportunities
          <ExternalLink className="size-3" />
        </div>
      </Card>
    </Link>
  );
}
